import { useRef } from 'react';

export const useInfiniteScroll = <T extends HTMLElement>(callback: () => void) => {
    const scrollRef = useRef<T | null>(null);

    const onScroll = () => {
        if (scrollRef && scrollRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
            if (scrollTop + clientHeight === scrollHeight) {
              callback();
            } else if (scrollHeight * -1 + clientHeight === scrollTop) {
              callback();
            }
        }
    };

    return { scrollRef, onScroll };
};
